export const CONTENT_EDITOR_LOADED_ACTION = 'content_editor_loaded';
export const WIKI_CONTENT_EDITOR_TRACKING_LABEL = 'wiki_content_editor';
export const WIKI_FORMAT_LABEL = 'wiki_format';
export const WIKI_FORMAT_UPDATED_ACTION = 'wiki_format_updated';
export const WIKI_CONTAINER_TYPE = {
  PROJECT: 'project',
  GROUP: 'group',
};

export const WIKI_NOTES_SORT_ORDER = {
  CREATED_ASC: 'created_asc',
  CREATED_DESC: 'created_desc',
};

export const WIKI_NOTES_DEFAULT_SORT_ORDER = WIKI_NOTES_SORT_ORDER.CREATED_ASC;

export const WIKI_SORT_ORDER_STORAGE_KEY = 'sort_direction_wiki';

export const WIKI_RESTORE_VERSION_TRACKING_LABEL = 'wiki_restore_version';

export const WIKI_RESTORE_VERSION_ACTION = 'wiki_restore_version_initiated';

export const WIKI_RESTORE_VERSION_LABEL = 'wiki_restore_version_label';

export const WIKI_ICON = 'book';

export const WIKI_TEMPLATES_DIR = 'templates';
